import axios from 'axios';

const API_BASE = `${window.location.origin}/api`;

// Shared axios instance — cookies travel with every request.
const client = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// ---- Booking profile (authed) ----
export const bookingApi = {
  getProfile:        () => client.get('/booking/profile'),
  updateProfile:     (data) => client.put('/booking/profile', data),

  createEventType:   (data) => client.post('/booking/event-types', data),
  updateEventType:   (id, data) => client.patch(`/booking/event-types/${id}`, data),
  deleteEventType:   (id) => client.delete(`/booking/event-types/${id}`),

  listTeams:         () => client.get('/booking/teams'),
  createTeam:        (data) => client.post('/booking/teams', data),
  deleteTeam:        (id) => client.delete(`/booking/teams/${id}`),

  listExceptions:    () => client.get('/booking/exceptions'),
  upsertException:   (data) => client.post('/booking/exceptions', data),
  deleteException:   (day) => client.delete(`/booking/exceptions/${day}`),
};

// ---- Public booking (no auth) ----
export const publicBookingApi = {
  profile:    (slug)              => client.get(`/public/booking/${slug}`),
  eventType:  (slug, eventSlug)   => client.get(`/public/booking/${slug}/${eventSlug}`),
  slots:      (slug, eventSlug, dateIso) =>
    client.get(`/public/booking/${slug}/${eventSlug}/slots`, { params: { date_iso: dateIso } }),
  book:       (slug, eventSlug, data) =>
    client.post(`/public/booking/${slug}/${eventSlug}/book`, data),

  team:       (teamSlug) => client.get(`/public/booking/team/${teamSlug}`),
  teamSlots:  (teamSlug, dateIso) =>
    client.get(`/public/booking/team/${teamSlug}/slots`, { params: { date_iso: dateIso } }),
  teamBook:   (teamSlug, data)   => client.post(`/public/booking/team/${teamSlug}/book`, data),
};

// ---- Google Calendar OAuth (authed) ----
export const googleCalendarApi = {
  status:     () => client.get('/oauth/calendar/status'),
  start:      () => client.get('/oauth/calendar/start'),
  disconnect: () => client.delete('/oauth/calendar/disconnect'),
};
